import { Dialog, type TypographyProps } from '@tunasong/ui-lib'
import { type FC } from 'react'
import { ToolsMenuItems } from './tools-menu-items.js'

export interface ToolsDialogProps {
  open: boolean
  variant?: TypographyProps['variant']
  onClose: () => void
}

export const ToolsDialog: FC<ToolsDialogProps> = props => {
  const { variant } = props
  return (
    <Dialog fullScreen fullWidth title="Tools" {...props}>
      <ToolsMenuItems variant={variant} onClose={props.onClose} />
    </Dialog>
  )
}

export default ToolsDialog
